import "../../../../styles/screens/client-visit-details/manage-module/EventsListTable.css";
import { useDispatch, useSelector } from "react-redux";
import noRefuel from "../../../../assets/no-refuel.svg";

import Loader from "../../../common-components/Loader";
import { ResourcesLabels } from "../../../../util/Strings";
import ErrorAlert from "../../../common-components/ErrorAlert";
import ErrorMessages from "../../../../util/ErrorMessages";
import ResourcesListTableBody from "./ResourcesListTableBody";
import "../../../../styles/screens/client-visit-details/manage-module/SpeakersList.css";
import { resetErrorAlert } from "../../../../slices/ResourcesSlice";

function ResourcesListTable() {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.resources.resources);
  const isLoading = useSelector((state) => state.resources.isLoading);
  const errorMessageCode = useSelector((state) => state.resources.errorCode);

  function handleCloseErrorAlert() {
    dispatch(resetErrorAlert(false));
  }

  if (isLoading) {
    return <Loader />;
  }

  if (errorMessageCode) {
    return (
      <ErrorAlert
        show={errorMessageCode}
        onClickHandle={handleCloseErrorAlert}
        title="Error"
        subTitle={ErrorMessages(errorMessageCode)}
      />
    );
  }

  return (
    <>
      {data && data.length > 0 ? (
        <table>
          <thead>
            <tr className="table-header">
              <th>{ResourcesLabels.fileName}</th>
              <th>{ResourcesLabels.description}</th>
              <th>{ResourcesLabels.fileType}</th>
              <th>{ResourcesLabels.uploadedFile}</th>
              <th>{ResourcesLabels.thumbnailPhoto}</th>
              <th>{ResourcesLabels.allowDownload}</th>
              <th> </th>
            </tr>
          </thead>
          {data.map((dataItem) => {
            return (
              <ResourcesListTableBody editMode={true} dataItem={dataItem} />
            );
          })}
        </table>
      ) : (
        <></>
      )}
    </>
  );
}

export default ResourcesListTable;
